const videoPreview = document.querySelector(".js-video-preview-init");

if (videoPreview) {
    window.addEventListener("load", () => initVideoPreview(videoPreview));
}

function initVideoPreview(previewWrap) {
    const video = previewWrap.querySelector(".js-video-preview-autoplay-target");

    if (video) {
        video
            .querySelectorAll("source")
            .forEach((item) => item.setAttribute("src", item.dataset.src));

        video.addEventListener("playing", () => videoPreview.classList.add("loaded"));

        video.load();
    }
}
